import { render, staticRenderFns } from "./GlobalConfirmationDialogVuex.vue?vue&type=template&id=73b401b2&"
import script from "./GlobalConfirmationDialogVuex.vue?vue&type=script&lang=ts&"
export * from "./GlobalConfirmationDialogVuex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports